<template>
  <div id="paypal-button-container"></div>
</template>

<script>
export default {
  name: 'paypalButton',
  props: [],
  data () {
    return {
      frameWidth: '450px',
      showClo: false
    }
  },
  mounted () {
    var that = this
    // let locationHref = window.document.location.href
    var params = this.$route.params
    var orderData = localStorage.getItem('orderData')
    if (JSON.stringify(params) === '{}' && orderData !== '{}') {
      params = JSON.parse(orderData)
    }
    // 验证verify
    var token = this.$md5('0' + this.common.lfSignKey)
    if (localStorage.getItem('token')) {
      token = localStorage.getItem('token')
    }

    var language = that.common.languageSet(that)
    var currency = that.common.currencySet(that)
    var time = parseInt(new Date().getTime() / 1000)
    var sessionid = that.common.sessionidGet(that)

    var paypalButtonDataJson = {
      'token': token,
      'hotelid': params.hotelid,
      'checkin': params.checkin,
      'checkout': params.checkout,
      'room': params.room,
      'adult': params.adult,
      'child': params.child,
      'childNums': params.childNums,
      'product': params.product,
      'time': time,
      'source': params.source,
      'language': language,
      'orderno': params.orderno,
      'currency': currency,
      'sessionid': sessionid,
      'paymentOn': 'paypal',
      'paypalSmartButton': 'Y',
      'operation': 'paymentOrderData'
    }
    var paypalButtonData = this.common.encryptionData(paypalButtonDataJson, this)

    window.paypal.Buttons({
      createOrder: function () {
        // Set up the transaction
        return fetch('/api/orderBook', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(paypalButtonData)
        }).then(function (res) {
          return res.json()
        }).then(function (data) {
          return data.data.orderID
        })
      },

      onApprove: function (data, actions) {
        // Capture the funds from the transaction
        return fetch('/api/orderBook', {
          method: 'POST',
          headers: {
            'content-type': 'application/json'
          },
          body: JSON.stringify({
            'operation': 'paymentCallback',
            'payType': 'paypal',
            'roompaiOrderno': params.orderno,
            'time': time,
            'token': data.orderID,
            'user_token': token
          })
        }).then(function (res) {
          return res.json()
        }).then(function (details) {
          // Show a success message to the buyer
          alert('Transaction completed by ' + details.payer_given_name)
        })
      }
    }).render('#paypal-button-container')
  },
  methods: {}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/order/paypalButton.vue